import React, { useState } from "react";
import { toast } from "react-toastify";
import userServiceApi from "../api/userServiceApi";
import { getRequest, patchRequest } from "../api/http";
import { putRequest } from "../api/http";
import { TAB_KEYS } from "../config";
import { setMicroSiteActions } from "../store/actions";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useStore } from "../store";
import { setMicroSites } from "../store/actions";


export function useMicrosite() {
  const { micrositeId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation()
  const { dispatch } = useStore()

  const [microSiteLoading, setLoading] = useState(false);
  const [microSitePublishLoading, setPublishLoading] = useState(false);
  const [microSiteUpdateLoading, setUpdateLoading] = useState(false);



  // const [microSites, setMicroSites] = useState([])

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  };


  const getMicroSites = async () => {
    setLoading(true)
    try {
      const response = await getRequest(userServiceApi.getAllMicrosites(), {
        headers,
      });
      if (response && response.data) {

        const data = response.data;
        if (data.length > 0) {
          if (micrositeId) {
            navigate(`/${micrositeId}`, { state: state ? state : TAB_KEYS.corousel })
          } else {
            navigate(`/${data[0].id}`, { state: state ? state : TAB_KEYS.corousel })
          }
          dispatch(setMicroSites(data))
          // setMicroSites(data);
          setLoading(false)

        } else {
          setLoading(false)
        }
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  };

  const updateMicroSite = async (micrositeId, data) => {
    try {
      setUpdateLoading(true)
      const response = await putRequest(userServiceApi.publishMicrosite(micrositeId), data, { headers: { "Content-Type": "multipart/form-data" }, headers });
      if (response) {
        setUpdateLoading(false)
        toast.success('Microsite updated successfully')
        getMicroSites();
        dispatch(setMicroSiteActions({ activeKey: micrositeId, menuKey: 'edit', change: false }))

      } else {
        setUpdateLoading(false)
        toast.error('Update failed');
      }
    } catch (error) {
      setUpdateLoading(false)

      toast.error(error)
    }
  }

  const publishMicroSite = async (micrositeId, status) => {
    try {
      setPublishLoading(true)
      const response = await patchRequest(userServiceApi.publishMicrosite(micrositeId), {
        headers,
      });
      if (response) {
        setPublishLoading(false)
        toast.success(`Site ${status} successfully`);
        getMicroSites()
      } else {
        setPublishLoading(false)
        toast.error('update failed');
      }
    } catch (error) {
      setPublishLoading(false)
      toast.error(error.error);
    }

  }



  return {
    getMicroSites,
    microSiteLoading,
    publishMicroSite,
    microSitePublishLoading,
    updateMicroSite,
    microSiteUpdateLoading
  }
}